var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFasoft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 509,
    height: 148,
    viewBox: "0 0 509 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.002,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f559f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#35a1da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f559f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d559f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#35a1da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d559f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1",
    transform: "translate(0.061 0.219)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1",
    "data-name": "Ret\\xE2ngulo 1",
    width: 509,
    height: 148,
    transform: "translate(-0.061 -0.219)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fasoft_x0020_Aprovada.cdr",
    transform: "translate(14.176 13.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M491.437,433.081l-.719,1.49a55.1,55.1,0,0,0-5.769-.306h0a54.33,54.33,0,0,0-15.19,2.155h0l-1.009-1.38a3.622,3.622,0,0,0-4.592-1.425h0l-12.437,6.537a3.615,3.615,0,0,0-1.428,4.588h0l.548,1.566a54.549,54.549,0,0,0-13.51,16.116h0l-1.694-.262a3.619,3.619,0,0,0-4.254,2.237h0l-4.171,13.411a3.617,3.617,0,0,0,2.238,4.252h0l1.492.719a54.919,54.919,0,0,0-.306,5.765h0a54.232,54.232,0,0,0,2.156,15.182h0l-1.381,1.008a3.616,3.616,0,0,0-1.426,4.589h0l6.541,12.43a3.621,3.621,0,0,0,4.591,1.425h0l1.567-.548a54.512,54.512,0,0,0,16.126,13.5h0l-.263,1.693a3.617,3.617,0,0,0,2.238,4.253h0l13.421,4.167a3.616,3.616,0,0,0,4.254-2.236h0l.72-1.491a55.338,55.338,0,0,0,5.768.306h0a54.366,54.366,0,0,0,15.19-2.154h0l1.009,1.377a3.621,3.621,0,0,0,4.593,1.426h0l6.163-3.238-9.2-17.638a38.268,38.268,0,0,1-17.756,4.341h0a38.406,38.406,0,0,1-38.417-38.394h0a38.405,38.405,0,0,1,38.417-38.392h0A38.414,38.414,0,0,1,519.023,470.8h0l17.649-9.194-3.3-6.271a3.618,3.618,0,0,0-4.59-1.426h0l-1.566.548a54.548,54.548,0,0,0-16.127-13.5h0l.262-1.694a3.616,3.616,0,0,0-2.238-4.253h0l-13.421-4.168a3.152,3.152,0,0,0-.931-.143h0a3.857,3.857,0,0,0-3.323,2.381Z",
    transform: "translate(-427.069 -430.324)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M1139.65,1199.528l8.4.728a26.227,26.227,0,0,1,19.712-23.153h0l-2.061-8.173A34.661,34.661,0,0,0,1139.65,1199.528Zm69.18,2.988v-.086c0-.89-.038-1.776-.107-2.649h0l-8.407.665q.081,1.024.08,2.069h0a26.213,26.213,0,0,1-.65,5.815h0l8.227,1.87A34.73,34.73,0,0,0,1208.83,1202.517Zm-11.406-12.124a26.035,26.035,0,0,1,2.614,7.783h0l8.317-1.4a34.359,34.359,0,0,0-3.453-10.288h0Zm-54.346,27.419a34.659,34.659,0,0,0,31.1,19.337h0a34.507,34.507,0,0,0,15.975-3.893h0l-3.888-7.481a26.1,26.1,0,0,1-12.087,2.947h0a26.227,26.227,0,0,1-23.53-14.634h0Zm45.57,6.558,4.655,7.03a34.883,34.883,0,0,0,7.88-7.18h0l-6.573-5.284a26.357,26.357,0,0,1-5.961,5.434Z",
    transform: "translate(-1116.235 -1144.296)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M1614.595,1934.825v-5.409l-7.1-4.082,7.1-4.081v-5.444l-11.685,7.24v4.549Z",
    transform: "translate(-1564.272 -1866.633)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M2209.913,1851.93l-3.763,23.229h2.114l3.784-23.229Z",
    transform: "translate(-2147.689 -1804.853)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M2417.57,1915.81v5.444l7.1,4.081-7.1,4.082v5.409l11.684-7.226v-4.549Z",
    transform: "translate(-2352.162 -1866.633)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M4200.271,423.631l-1.318,7.992a3.106,3.106,0,0,1-2.881,2.5h-24.487c-6.959,0-9.839,2.5-11.281,10.739l-2.279,13.488h32.526a2,2,0,0,1,2.041,2.122v.374l-1.562,8.991a3.1,3.1,0,0,1-2.88,2.5h-32.523l-6.363,38.213a3.1,3.1,0,0,1-2.881,2.5h-11.764a1.867,1.867,0,0,1-1.92-2v-.5l11.043-65.686c3.6-21.229,14.161-25.6,32.047-25.6,14.281,0,18.843,1.125,22.563,1.749,1.44.249,2.042.623,2.042,1.747C4200.394,423.006,4200.271,423.257,4200.271,423.631Z",
    transform: "translate(-4010.932 -419.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M6241.489,1073.335c-10.463,0-14.361,7.029-16.185,17.948l-1.583,9.664a42.436,42.436,0,0,0-.73,7.279c0,6.9,2.8,10.67,10.71,10.67a71.507,71.507,0,0,0,11.807-.878l7.422-43.8A64.469,64.469,0,0,0,6241.489,1073.335Zm28.844-6.9-10.1,59.365c-.365,1.882-.976,2.635-3.9,3.387a107.083,107.083,0,0,1-24.946,3.265c-16.553,0-24.341-10.167-24.341-24.349a50.315,50.315,0,0,1,.608-7.154l1.582-9.664c3.529-21.713,14.968-31.5,34.564-31.5a93.58,93.58,0,0,1,23.851,3.265c2.19.626,2.8,1.254,2.8,2.384A3.186,3.186,0,0,1,6270.333,1066.433Z",
    transform: "translate(-6017.121 -1038.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M8356.756,1063.754l-1.258,7.182c-.25,1.513-1.128,2.4-2.383,2.4h-.5a164.128,164.128,0,0,0-19.839-1.513c-3.894,0-9.669.5-9.669,5.8,0,1.763,1.259,3.4,3.77,5.167l14.688,10.081c7.532,5.167,9.291,10.334,9.291,15.88,0,15.752-12.8,22.431-27.749,22.431-4.144,0-14.941-.378-22.6-2.521a2.266,2.266,0,0,1-1.887-2.268v-.63L8300,1118.2a2.578,2.578,0,0,1,2.635-2.015h.379c5.9.757,16.323,1.387,20.088,1.387,6.15,0,10.8-1.134,10.8-7.059,0-2.015-1.129-3.905-4.144-6.048l-15.317-10.586a18.652,18.652,0,0,1-8.16-15c0-16.635,14.437-20.667,26.492-20.667a91.693,91.693,0,0,1,22.224,2.648,2.154,2.154,0,0,1,1.759,2.267v.63Z",
    transform: "translate(-8039.961 -1037.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M10256.457,1070.416c-7.123,0-13.193,4.553-15.295,17.071l-1.75,10.243a32.593,32.593,0,0,0-.469,5.565c0,7.461,3.385,11.509,10.273,11.509,8.178,0,13.2-5.313,15.18-17.073l1.752-10.243a32.555,32.555,0,0,0,.467-5.563C10266.615,1074.464,10263.346,1070.416,10256.457,1070.416Zm25.105,17.071-1.754,10.243c-3.621,20.864-14.594,31.488-32.924,31.488-15.883,0-23.355-12.139-23.355-25.417a35.313,35.313,0,0,1,.469-6.071l1.75-10.243c3.736-22,14.715-31.488,33.043-31.488,16,0,23.352,11.635,23.352,24.912A41.986,41.986,0,0,1,10281.563,1087.487Z",
    transform: "translate(-9901.62 -1035.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M12219.82,438.731l-1.246,7.13c-.25,1.33-.871,2.055-2.244,2.055h-10.85c-5.738,0-7.609,1.087-8.73,7.251l-1.123,5.924h17.586a2,2,0,0,1,2.121,2.054v.362l-1.371,7.252a2.92,2.92,0,0,1-2.867,2.3h-17.59l-9.729,53.661a3.273,3.273,0,0,1-2.988,2.539h-11.479a2.1,2.1,0,0,1-2.117-2.176v-.363l12.967-71.549c2.869-15.59,11.975-19.338,24.57-19.338a100.345,100.345,0,0,1,13.223.967c1.5.242,1.867.6,1.867,1.45Z",
    transform: "translate(-11781.415 -435.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M13661.69,753.583l-1.293,7.142a3.235,3.235,0,0,1-3.08,2.42h-18.143l-7.336,39.093a15.953,15.953,0,0,0-.254,2.179c0,2.9,1.926,3.51,7.074,3.51h10.16c1.162,0,2.32.362,2.32,1.452v.364l-1.418,7.5c-.256,1.209-1.154,1.937-2.83,2.179a122.546,122.546,0,0,1-15.182.968c-9.777,0-17.369-3.994-17.369-13.917a26.094,26.094,0,0,1,.385-4.237l11.449-61a3.392,3.392,0,0,1,2.963-2.421l12.352-1.936h.385a1.865,1.865,0,0,1,1.8,2.058v.362l-2.311,11.861h18.137a2.11,2.11,0,0,1,2.191,2.058v.363Z",
    transform: "translate(-13181.008 -726.443)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(121.521 99.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M4132.919,3450.37h-.061c-3.136,0-4.929.809-5.51,4.068h0l-2.129,11.9v.1a.336.336,0,0,0,.358.341h1.145a.569.569,0,0,0,.537-.437h0l1.276-7.151h6.878a.569.569,0,0,0,.536-.438h0l.135-.83v-.09a.336.336,0,0,0-.359-.348h-6.877l.539-3.042c.269-1.486.807-2.274,3.181-2.274h4.323a.286.286,0,0,0,.29-.261h0l.181-1.05v-.065a.219.219,0,0,0-.158-.241h0C4136.61,3450.48,4134.254,3450.374,4132.919,3450.37Z",
    transform: "translate(-4125.22 -3450.173)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_55",
    "data-name": "Caminho 55",
    d: "M4500.627,3579.716h0v-.011c0-.189-.115-.276-.4-.341h0a18.573,18.573,0,0,0-4.1-.5c-3.429,0-5.109,1.859-5.782,5.4l-.289,1.531a7.894,7.894,0,0,0-.135,1.421h0c0,2.385,1.322,3.982,4.056,3.982h0a20.18,20.18,0,0,0,4.211-.5h0c.4-.087.515-.2.559-.5h0l1.858-10.323A1.4,1.4,0,0,1,4500.627,3579.716Zm-8.78,7.607a8.207,8.207,0,0,1,.179-1.53h0l.291-1.531c.426-2.23,1.434-3.785,3.584-3.785h0a16.293,16.293,0,0,1,2.575.219h0l-1.545,8.663a17.675,17.675,0,0,1-2.665.218h0c-1.77,0-2.419-.786-2.419-2.253Z",
    transform: "translate(-4477.936 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_56",
    "data-name": "Caminho 56",
    d: "M4851.206,3578.86h-.049c-3.069,0-5.129,1.771-5.734,5.315h0l-.289,1.705a7.39,7.39,0,0,0-.114,1.167v.037c0,2.338,1.3,4.111,3.921,4.111h0a17.377,17.377,0,0,0,2.845-.241h0c.356-.066.492-.175.538-.479h0l.134-.788v-.066c0-.177-.157-.263-.337-.263h-.065a23.229,23.229,0,0,1-2.823.152h0c-1.456,0-2.264-.655-2.264-2.318h0a7.33,7.33,0,0,1,.136-1.313h0l.29-1.705c.382-2.252,1.679-3.631,3.471-3.631h0a21.648,21.648,0,0,1,2.737.153h.064a.453.453,0,0,0,.469-.329h0l.138-.787c0-.064.021-.11.021-.153h0c0-.2-.109-.284-.381-.327h0A16.029,16.029,0,0,0,4851.206,3578.86Z",
    transform: "translate(-4821.368 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_57",
    "data-name": "Caminho 57",
    d: "M5161.808,3583.937v-.1a.313.313,0,0,0-.3-.341h-1.174a.52.52,0,0,0-.493.437h0l-1.186,6.608c-.474,2.582-1.681,3.455-3.227,3.455h-.2c-1.253,0-2.173-.548-2.173-2.275h0a5.825,5.825,0,0,1,.112-1.18h0l1.188-6.608v-.087a.315.315,0,0,0-.3-.35h-1.175a.523.523,0,0,0-.493.437h0l-1.141,6.344a7.893,7.893,0,0,0-.135,1.376h0a3.746,3.746,0,0,0,3.829,4.026h.2c1.9,0,4.7-.831,5.487-5.139h0Z",
    transform: "translate(-5117.391 -3578.929)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_58",
    "data-name": "Caminho 58",
    d: "M5506.587,3449.05H5505.4a.5.5,0,0,0-.481.416h0l-2.8,15.6v.1a.312.312,0,0,0,.312.341h1.167a.523.523,0,0,0,.494-.437h0l2.8-15.6v-.087A.3.3,0,0,0,5506.587,3449.05Z",
    transform: "translate(-5456.875 -3448.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_59",
    "data-name": "Caminho 59",
    d: "M5661.6,3465.651h.063a23.2,23.2,0,0,0,4.127-.372h0c.4-.065.516-.218.559-.5h0l2.755-15.311v-.1a.294.294,0,0,0-.312-.319h-1.143a.551.551,0,0,0-.516.416h0l-.739,4.068a15.8,15.8,0,0,0-2.575-.218h0c-3.271,0-5.152,1.6-5.848,5.359h0l-.29,1.575a7.422,7.422,0,0,0-.135,1.376h0A3.684,3.684,0,0,0,5661.6,3465.651Zm-2.1-3.981a8.787,8.787,0,0,1,.156-1.42h0l.291-1.575c.4-2.123,1.389-3.676,3.585-3.676h0a17.2,17.2,0,0,1,2.575.152h0l-1.567,8.685c-.783.065-1.882.131-2.644.131h0c-1.725,0-2.4-.809-2.4-2.3Z",
    transform: "translate(-5607.197 -3448.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M6012.671,3587.172v.042c0,2.385,1.321,3.982,4.055,3.982h0a20.146,20.146,0,0,0,4.209-.5h0c.405-.087.515-.2.562-.5h0l1.858-10.323c0-.066.021-.109.021-.152h0c0-.2-.111-.284-.4-.35h0a18.582,18.582,0,0,0-4.1-.5c-3.428,0-5.107,1.859-5.779,5.4l-.293,1.531A7.941,7.941,0,0,0,6012.671,3587.172Zm1.925.152a8.375,8.375,0,0,1,.179-1.53h0l.293-1.531c.425-2.23,1.433-3.785,3.583-3.785h0a16.2,16.2,0,0,1,2.577.22h0l-1.547,8.662a17.667,17.667,0,0,1-2.666.218h0c-1.769,0-2.419-.786-2.419-2.253Z",
    transform: "translate(-5950.649 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_61",
    "data-name": "Caminho 61",
    d: "M6371.145,3465.651h.064a23.178,23.178,0,0,0,4.124-.372h0c.4-.065.514-.218.561-.5h0l2.755-15.311v-.1a.3.3,0,0,0-.313-.319h-1.144a.544.544,0,0,0-.513.416h0l-.741,4.068a15.783,15.783,0,0,0-2.576-.218h0c-3.271,0-5.151,1.6-5.847,5.359h0l-.29,1.575a7.426,7.426,0,0,0-.136,1.376h0A3.685,3.685,0,0,0,6371.145,3465.651Zm-2.105-3.981a8.776,8.776,0,0,1,.155-1.42h0l.292-1.575c.4-2.123,1.39-3.676,3.585-3.676h0a17.239,17.239,0,0,1,2.577.152h0l-1.57,8.685c-.785.065-1.882.131-2.645.131h0c-1.723,0-2.395-.809-2.395-2.3Z",
    transform: "translate(-6293.422 -3448.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_62",
    "data-name": "Caminho 62",
    d: "M6723.579,3587.111v.039c0,2.953,2.2,4.046,4.415,4.046h0a20.333,20.333,0,0,0,3.921-.372h0c.381-.066.49-.2.534-.5h0l.136-.744v-.087c0-.173-.112-.218-.289-.218h-.136a29.29,29.29,0,0,1-3.875.306h0c-1.727,0-2.8-.7-2.8-2.34h0a5.011,5.011,0,0,1,.179-1.333h0l.065-.265h7.5c.337,0,.427-.2.494-.48h0l.18-.92a6.819,6.819,0,0,0,.134-1.312h0a3.768,3.768,0,0,0-4.1-4.067c-3.181,0-5.266,1.925-5.937,5.4l-.289,1.531A7.314,7.314,0,0,0,6723.579,3587.111Zm2.42-3.045c.4-2.011,1.7-3.521,3.651-3.521h0c1.593,0,2.42.765,2.42,2.32h0a6.139,6.139,0,0,1-.136,1.2h0l-.02.11h-5.936Z",
    transform: "translate(-6638.197 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_63",
    "data-name": "Caminho 63",
    d: "M7255.936,3465.651H7256a23.189,23.189,0,0,0,4.125-.372h0c.4-.065.516-.218.56-.5h0l2.755-15.311v-.087a.3.3,0,0,0-.312-.329h-1.145a.55.55,0,0,0-.515.416h0l-.737,4.068a15.821,15.821,0,0,0-2.577-.218h0c-3.271,0-5.152,1.6-5.847,5.359h0l-.291,1.575a7.667,7.667,0,0,0-.135,1.335v.041A3.685,3.685,0,0,0,7255.936,3465.651Zm-2.106-3.981a8.808,8.808,0,0,1,.158-1.42h0l.292-1.575c.4-2.123,1.387-3.676,3.582-3.676h0a17.175,17.175,0,0,1,2.575.152h0l-1.567,8.685c-.782.065-1.881.131-2.645.131h0c-1.724,0-2.4-.809-2.4-2.3Z",
    transform: "translate(-7149.139 -3448.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_64",
    "data-name": "Caminho 64",
    d: "M7608.795,3584.263l-.293,1.531a7.462,7.462,0,0,0-.132,1.356h0c0,2.953,2.192,4.046,4.411,4.046h0a20.28,20.28,0,0,0,3.921-.372h0c.381-.066.492-.2.536-.5h0l.136-.744v-.087c0-.173-.111-.218-.291-.218h-.134a29.321,29.321,0,0,1-3.877.306h0c-1.724,0-2.8-.7-2.8-2.34h0a5.066,5.066,0,0,1,.182-1.333h0l.066-.265h7.506c.335,0,.425-.2.492-.48h0l.18-.92a6.811,6.811,0,0,0,.132-1.312h0a3.767,3.767,0,0,0-4.1-4.067C7611.55,3578.86,7609.469,3580.785,7608.795,3584.263Zm1.992-.2c.406-2.011,1.7-3.521,3.653-3.521h0c1.591,0,2.417.765,2.417,2.32h0a6.044,6.044,0,0,1-.133,1.2h0l-.022.11h-5.937Z",
    transform: "translate(-7493.915 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_65",
    "data-name": "Caminho 65",
    d: "M8154.353,3466.929h.063c1.332,0,3.685-.09,4.326-.154h0a.385.385,0,0,0,.269-.306h0l.2-1.072v-.065a.187.187,0,0,0-.2-.2h-4.323c-1.882,0-2.441-.393-2.441-1.377h0a4.872,4.872,0,0,1,.111-.9h0l.649-3.672h6.877a.57.57,0,0,0,.538-.438h0l.134-.831v-.09a.336.336,0,0,0-.359-.348h-6.876l.536-3.042c.293-1.662.808-2.274,3.184-2.274h4.321a.289.289,0,0,0,.292-.262h0l.181-1.049v-.075a.218.218,0,0,0-.158-.231h0c-.605-.066-3.021-.176-4.345-.176h0c-3.136,0-4.93.854-5.512,4.068h0l-1.5,8.42a4.544,4.544,0,0,0-.09.92h0C8150.229,3465.9,8151.8,3466.929,8154.353,3466.929Z",
    transform: "translate(-8017.968 -3450.173)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_66",
    "data-name": "Caminho 66",
    d: "M8489.3,3591.043h1.18a.522.522,0,0,0,.49-.437h0l1.41-7.809c.293-1.575.9-2.273,2.4-2.273h1.5c1.256,0,1.682.438,1.682,1.333h0a4.832,4.832,0,0,1-.092.94h0l-1.41,7.809v.087a.311.311,0,0,0,.3.35h1.176a.515.515,0,0,0,.49-.437h0l1.365-7.612a6.9,6.9,0,0,0,.117-1.113h0c0-2.452-1.816-3.021-3.32-3.021h-1.5c-1.859,0-4.055.416-4.66,3.763h0l-1.436,7.983v.1A.312.312,0,0,0,8489.3,3591.043Z",
    transform: "translate(-8345.607 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_67",
    "data-name": "Caminho 67",
    d: "M8840.719,3594.6v.012c.008.193.139.277.381.343h0a15.775,15.775,0,0,0,3.742.392c3.225,0,4.727-.939,5.33-4.331h0l2.018-11.155c0-.066.021-.109.021-.152h0c0-.175-.113-.284-.4-.35h0a18.674,18.674,0,0,0-3.92-.5h0c-3.361,0-5.244,1.423-5.959,5.359l-.289,1.6a8.465,8.465,0,0,0-.137,1.464h0c0,2.756,1.748,3.916,4.166,3.916h0a15.63,15.63,0,0,0,2.555-.307h0l-.045.219c-.4,1.969-1.053,2.67-3.047,2.67h0c-1.187,0-2.98-.176-3.74-.263h-.068a.457.457,0,0,0-.469.35h0l-.113.634C8840.742,3594.541,8840.721,3594.563,8840.719,3594.6Zm2.732-7.235a8.636,8.636,0,0,1,.156-1.553h0l.295-1.6c.471-2.56,1.613-3.742,3.693-3.742h0a14.234,14.234,0,0,1,2.465.242h0l-1.547,8.617a15.161,15.161,0,0,1-2.553.241h0c-1.7,0-2.51-.547-2.51-2.208Z",
    transform: "translate(-8685.77 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_68",
    "data-name": "Caminho 68",
    d: "M9221.1,3587.111v.039c0,2.953,2.193,4.046,4.412,4.046h0a20.315,20.315,0,0,0,3.92-.372h0c.379-.066.49-.2.537-.5h0l.133-.744v-.087c0-.173-.111-.218-.291-.218h-.133a29.334,29.334,0,0,1-3.877.306h0c-1.725,0-2.8-.7-2.8-2.34h0a5.047,5.047,0,0,1,.178-1.333h0l.072-.265h7.5c.332,0,.426-.2.494-.48h0l.176-.92a7,7,0,0,0,.139-1.312h0a3.773,3.773,0,0,0-4.1-4.067c-3.182,0-5.262,1.925-5.934,5.4l-.3,1.531A7.534,7.534,0,0,0,9221.1,3587.111Zm2.42-3.045c.4-2.011,1.7-3.521,3.648-3.521h0c1.588,0,2.42.765,2.42,2.32h0a5.727,5.727,0,0,1-.137,1.2h0l-.02.11h-5.939Z",
    transform: "translate(-9053.649 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_69",
    "data-name": "Caminho 69",
    d: "M9567.615,3591.043h1.174a.519.519,0,0,0,.494-.437h0l1.408-7.809c.295-1.575.9-2.273,2.4-2.273h1.5c1.256,0,1.684.438,1.684,1.333h0a5.337,5.337,0,0,1-.092.94h0l-1.412,7.809v.087a.312.312,0,0,0,.3.35h1.174a.512.512,0,0,0,.492-.437h0l1.369-7.612a6.852,6.852,0,0,0,.113-1.113h0c0-2.452-1.816-3.021-3.316-3.021h-1.5c-1.857,0-4.055.416-4.66,3.763h0l-1.436,7.983v.1A.314.314,0,0,0,9567.615,3591.043Z",
    transform: "translate(-9388.481 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_70",
    "data-name": "Caminho 70",
    d: "M9944.271,3456.841v-.026c0-1.969-1.3-3.5-4.189-3.5h0a12.746,12.746,0,0,0-2.623.305h0l.74-4.155v-.087a.313.313,0,0,0-.326-.329h-1.15a.526.526,0,0,0-.5.416h0l-2.8,15.6v.086a.337.337,0,0,0,.359.35h1.074a.568.568,0,0,0,.537-.437h0l1.746-9.777a10.846,10.846,0,0,1,2.645-.329h0c1.746,0,2.506.546,2.506,1.882h0a4.309,4.309,0,0,1-.086.874h0l-1.324,7.351v.086a.339.339,0,0,0,.359.35h1.076a.566.566,0,0,0,.537-.437h0l1.32-7.351A6.566,6.566,0,0,0,9944.271,3456.841Z",
    transform: "translate(-9742.572 -3448.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_71",
    "data-name": "Caminho 71",
    d: "M10319.71,3579.716h0v-.011c0-.189-.119-.276-.4-.341h0a18.585,18.585,0,0,0-4.1-.5c-3.427,0-5.106,1.859-5.781,5.4l-.286,1.531a7.819,7.819,0,0,0-.138,1.421h0c0,2.385,1.318,3.982,4.054,3.982h0a20.15,20.15,0,0,0,4.212-.5h0c.405-.087.514-.2.563-.5h0l1.857-10.323A1.166,1.166,0,0,1,10319.71,3579.716Zm-8.782,7.607a8.125,8.125,0,0,1,.179-1.53h0l.294-1.531c.422-2.23,1.434-3.785,3.581-3.785h0a16.363,16.363,0,0,1,2.577.219h0l-1.546,8.663a17.664,17.664,0,0,1-2.665.218h0c-1.769,0-2.42-.786-2.42-2.253Z",
    transform: "translate(-10105.802 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_72",
    "data-name": "Caminho 72",
    d: "M10654.275,3591.043h1.174a.518.518,0,0,0,.49-.437h0l1.771-9.844a15.024,15.024,0,0,1,3.162-.219h0c.424,0,.467-.109.514-.35h0l.2-1.006v-.1c-.008-.209-.162-.231-.428-.231h0a12.971,12.971,0,0,0-4.793.612h0a.715.715,0,0,0-.492.505h0l-1.9,10.629v.087A.316.316,0,0,0,10654.275,3591.043Z",
    transform: "translate(-10439.437 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_73",
    "data-name": "Caminho 73",
    d: "M10892.42,3445.08a.573.573,0,0,0-.539.437h0l-.312,1.749v.088a.337.337,0,0,0,.357.35h1.145a.565.565,0,0,0,.535-.438h0l.313-1.749v-.087a.335.335,0,0,0-.355-.35h-1.143Zm-2.99,16.579h1.082a.567.567,0,0,0,.541-.437h0l1.99-11.157v-.087a.335.335,0,0,0-.354-.35h-1.074a.569.569,0,0,0-.541.437h0l-1.99,11.157v.1A.332.332,0,0,0,10889.43,3461.659Z",
    transform: "translate(-10666.826 -3445.057)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_74",
    "data-name": "Caminho 74",
    d: "M11045.8,3587.172v.042c0,2.385,1.322,3.982,4.055,3.982h0a20.125,20.125,0,0,0,4.211-.5h0c.4-.087.516-.2.563-.5h0l1.857-10.323c0-.066.021-.109.021-.152h0c0-.2-.113-.284-.4-.35h0a18.573,18.573,0,0,0-4.1-.5c-3.428,0-5.105,1.859-5.781,5.4l-.287,1.531A7.869,7.869,0,0,0,11045.8,3587.172Zm1.928.152a8.281,8.281,0,0,1,.178-1.53h0l.291-1.531c.424-2.23,1.434-3.785,3.584-3.785h0a16.241,16.241,0,0,1,2.576.22h0l-1.547,8.662a17.655,17.655,0,0,1-2.666.218h0c-1.77,0-2.416-.786-2.416-2.253Z",
    transform: "translate(-10818.394 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_75",
    "data-name": "Caminho 75",
    d: "M11576.764,3465.651h.063a23.148,23.148,0,0,0,4.125-.372h0c.4-.065.518-.218.561-.5h0l2.756-15.311v-.087a.3.3,0,0,0-.311-.329h-1.148a.544.544,0,0,0-.512.416h0l-.738,4.068a15.833,15.833,0,0,0-2.578-.218h0c-3.27,0-5.15,1.6-5.848,5.359h0l-.291,1.575a7.753,7.753,0,0,0-.133,1.335v.041A3.682,3.682,0,0,0,11576.764,3465.651Zm-2.107-3.981a9.227,9.227,0,0,1,.154-1.42h0l.295-1.575c.4-2.123,1.389-3.676,3.584-3.676h0a17.18,17.18,0,0,1,2.576.152h0l-1.568,8.685c-.783.065-1.881.131-2.645.131h0c-1.725,0-2.4-.809-2.4-2.3Z",
    transform: "translate(-11327.984 -3448.896)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_76",
    "data-name": "Caminho 76",
    d: "M11939.719,3582.966v-.039a3.768,3.768,0,0,0-4.1-4.067c-3.182,0-5.266,1.925-5.936,5.4l-.289,1.531a7.3,7.3,0,0,0-.135,1.356h0c0,2.953,2.193,4.046,4.41,4.046h0a20.176,20.176,0,0,0,3.92-.373h0c.387-.064.492-.2.539-.5h0l.133-.744v-.087c0-.174-.111-.219-.285-.219h-.141a29.293,29.293,0,0,1-3.871.306h0c-1.729,0-2.8-.7-2.8-2.34h0a5.056,5.056,0,0,1,.18-1.332h0l.066-.264h7.506c.336,0,.424-.2.494-.481h0l.178-.919A6.73,6.73,0,0,0,11939.719,3582.966Zm-8.043,1.1c.406-2.011,1.705-3.521,3.654-3.521h0c1.588,0,2.418.766,2.418,2.319h0a6.286,6.286,0,0,1-.135,1.2h0l-.023.11h-5.936Z",
    transform: "translate(-11672.82 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_77",
    "data-name": "Caminho 77",
    d: "M12451.43,3466.928h.059c3.584,0,6.254-1.6,6.254-4.833h0c0-1.444-.744-2.6-2.826-3.96h0l-1.84-1.2c-1.477-.962-1.994-1.486-1.994-2.274h0c0-2.187,1.908-2.494,3.721-2.494h0c1.3,0,2.871.066,3.855.13h.047a.415.415,0,0,0,.445-.348h0l.158-.941v-.074a.316.316,0,0,0-.318-.3h0a35.521,35.521,0,0,0-4.187-.265h0c-2.889,0-5.754,1.1-5.754,4.4h0c0,1.312.918,2.559,2.439,3.564h0l1.947,1.29c1.568,1.051,2.15,1.575,2.15,2.473h0c0,2.229-1.5,3.041-3.918,3.041h0c-1.031,0-2.664-.043-3.676-.132h-.066a.411.411,0,0,0-.445.35h0l-.156.874a.882.882,0,0,1-.023.111h0c0,.2.133.242.381.284h0A28.106,28.106,0,0,0,12451.43,3466.928Z",
    transform: "translate(-12173.84 -3450.173)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_78",
    "data-name": "Caminho 78",
    d: "M12829.973,3583.007v-.037a3.793,3.793,0,0,0-4.141-4.111c-3.342,0-5.312,1.794-5.941,5.336l-.289,1.662a7.223,7.223,0,0,0-.113,1.2h0a3.818,3.818,0,0,0,4.121,4.136h0c3.539,0,5.377-2.014,5.959-5.339h0l.295-1.661A9.015,9.015,0,0,0,12829.973,3583.007Zm-8.535,4.143a6.559,6.559,0,0,1,.137-1.292h0l.285-1.661c.385-2.23,1.729-3.653,3.676-3.653h0c1.75,0,2.467.831,2.467,2.407h0a6.7,6.7,0,0,1-.111,1.246h0l-.295,1.661c-.377,2.145-1.725,3.654-3.7,3.654h0c-1.742,0-2.461-.809-2.461-2.362Z",
    transform: "translate(-12533.795 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_79",
    "data-name": "Caminho 79",
    d: "M13172.8,3444.38h-.039c-2.037,0-3.539.482-4.008,3.04h0l-2.375,13.125v.1a.339.339,0,0,0,.359.341h1.076a.564.564,0,0,0,.537-.437h0l1.838-10.063h3.494a.505.505,0,0,0,.492-.392h0l.133-.745v-.065a.32.32,0,0,0-.355-.33h-3.5l.268-1.531c.2-1.136.516-1.487,1.75-1.487h1.99c.314,0,.494-.087.539-.307h0l.135-.744v-.086c0-.153-.092-.241-.381-.286h0A14.109,14.109,0,0,0,13172.8,3444.38Z",
    transform: "translate(-12869.287 -3444.38)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_80",
    "data-name": "Caminho 80",
    d: "M13410.543,3515.247h.039a17.247,17.247,0,0,0,2.133-.132h0c.357-.043.473-.174.52-.371h0l.133-.745v-.064c0-.175-.133-.242-.426-.242h-1.816c-1.01,0-1.453-.152-1.453-.9h0a3,3,0,0,1,.066-.592h0l1.387-7.611h3.5a.5.5,0,0,0,.492-.392h0l.135-.745v-.065a.32.32,0,0,0-.355-.329h-3.5l.428-2.316v-.068a.341.341,0,0,0-.312-.349h-.045l-1.121.175a.632.632,0,0,0-.537.415h0l-2.041,11.286a4.719,4.719,0,0,0-.064.723v.021C13407.7,3514.5,13408.775,3515.247,13410.543,3515.247Z",
    transform: "translate(-13102.678 -3498.491)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_81",
    "data-name": "Caminho 81",
    d: "M13661.557,3583.5h-1.064a.571.571,0,0,0-.537.436h0l-1.23,6.848c-.406,2.3-1.545,3.259-3.338,3.259h0a7.414,7.414,0,0,1-1.746-.284h0l1.768-9.823v-.086a.335.335,0,0,0-.348-.349h-1.111a.567.567,0,0,0-.533.436h0l-1.771,9.823a8.59,8.59,0,0,1-1.834.284h0c-1.525,0-2.311-.459-2.311-1.989h0a6.96,6.96,0,0,1,.135-1.27h0l1.234-6.848v-.086a.337.337,0,0,0-.348-.349h-1.066a.568.568,0,0,0-.537.436h0l-1.232,6.849a6.888,6.888,0,0,0-.133,1.253v.037c0,2.646,1.813,3.609,3.785,3.609h0a9.568,9.568,0,0,0,3.068-.524h0a7.907,7.907,0,0,0,2.869.524h0c2.531,0,4.68-.963,5.4-4.9h0l1.234-6.849v-.086A.336.336,0,0,0,13661.557,3583.5Z",
    transform: "translate(-13332.717 -3578.929)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M14181.885,3579.739v-.073c-.016-.164-.135-.242-.4-.3h0a18.609,18.609,0,0,0-4.1-.5c-3.426,0-5.109,1.859-5.779,5.4l-.293,1.531a8.161,8.161,0,0,0-.133,1.421h0c0,2.385,1.322,3.982,4.053,3.982h0a20.159,20.159,0,0,0,4.213-.5h0c.4-.087.518-.2.561-.5h0l1.859-10.323A.517.517,0,0,1,14181.885,3579.739Zm-8.779,7.585a8.125,8.125,0,0,1,.178-1.53h0l.289-1.531c.428-2.23,1.436-3.785,3.584-3.785h0a16.162,16.162,0,0,1,2.578.22h0l-1.547,8.662a17.627,17.627,0,0,1-2.664.218h0c-1.771,0-2.418-.786-2.418-2.253Z",
    transform: "translate(-13841.069 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M14516.373,3591.043h1.178a.522.522,0,0,0,.492-.437h0l1.768-9.844a15.017,15.017,0,0,1,3.158-.219h0c.43,0,.473-.109.516-.35h0l.2-1.006v-.1c-.006-.209-.164-.231-.43-.231h0a12.943,12.943,0,0,0-4.791.612h0a.691.691,0,0,0-.49.505h0l-1.908,10.629v.087A.316.316,0,0,0,14516.373,3591.043Z",
    transform: "translate(-14174.628 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M14754.6,3587.111v.039c0,2.953,2.2,4.046,4.41,4.046h0a20.3,20.3,0,0,0,3.92-.372h0c.377-.066.49-.2.539-.5h0l.135-.744v-.087c0-.173-.113-.218-.3-.218h-.133a29.2,29.2,0,0,1-3.875.306h0c-1.725,0-2.8-.7-2.8-2.34h0a5.139,5.139,0,0,1,.18-1.333h0l.07-.265h7.5c.336,0,.424-.2.494-.48h0l.176-.92a6.671,6.671,0,0,0,.135-1.312h0a3.768,3.768,0,0,0-4.1-4.067c-3.182,0-5.26,1.925-5.936,5.4l-.291,1.531A7.546,7.546,0,0,0,14754.6,3587.111Zm2.414-3.045c.406-2.011,1.707-3.521,3.654-3.521h0c1.588,0,2.416.765,2.416,2.32h0a6.1,6.1,0,0,1-.131,1.2h0l-.023.11h-5.937Z",
    transform: "translate(-14405.322 -3574.441)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-31)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasoft);
export default __webpack_public_path__ + "static/media/fasoft.bd6a16b55cbd2fa3b1916501c6410644.svg";
export { ForwardRef as ReactComponent };